module.exports = __webpack_public_path__ + "img/pasta-1.0286fbed.jpg";